import React from "react";
import SearchBar from "@/components/SearchBar.js";
import CustomSlider from "@/components/CustomSlider";
import Card from "@/components/Card";
import Footer from "@/layout/Footer";

const Search = () => {
	const productCards = [
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
	];
	return (
		<>
			<SearchBar />
			<div className="absolute top-[188px] left-[124px] w-[242px] h-[20px] flex gap-[4px] hidden lg:flex">
				<div className="w-[81px] h-[20px] flex items-center justify-between px-1">
					<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
						Electronic
					</span>
					{/* Icon */}
					<img
						src="assets/search/Icons/bread_crum_arrow.svg"
						alt="Electronic"
						className="w-[10px] h-[10px]"
					/>
				</div>
				<div className="w-[65px] h-[20px] flex items-center justify-between px-1">
					<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
						Gadgets
					</span>
					<img
						src="assets/search/Icons/bread_crum_arrow.svg"
						alt="Gadgets"
						className="w-[10px] h-[10px]"
					/>
				</div>
				<div className="w-[88px] h-[20px] flex items-center justify-between px-1">
					<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
						Smart Watches
					</span>
					<img
						src="assets/search/Icons/bread_crum_arrow.svg"
						alt="Gadgets"
						className="w-[10px] h-[10px]"
					/>
				</div>
			</div>

			<div className="absolute top-[228px] left-[124px] w-[411px] h-[28px] flex items-baseline hidden lg:flex">
				<div className="w-[121px] h-[28px] font-montserrat font-semibold text-[28px] leading-[32px] text-black">
					Results
				</div>
				<div className="w-[241px] h-[15px] flex gap-[4px] items-center pb-[5px]">
					<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#47645D]">
						1280 results of
					</span>
					<span className="font-montserrat font-semibold text-[12px] leading-[100%] text-[#47645D]">
						Smart Watch
					</span>
				</div>
			</div>
			<div className="absolute top-[272px] left-[124px] w-[513px] h-[20px] flex items-baseline gap-[8px] hidden lg:flex">
				<div className="h-[20px] flex items-center">
					<span className="font-montserrat font-semibold text-[13px] leading-[24px] text-black">
						Did you mean...
					</span>
				</div>

				<div className="flex items-baseline gap-[8px]">
					<a
						href="#"
						className="font-montserrat font-normal text-[12px] leading-[100%] underline text-[#5B64CF]"
					>
						Smart Tv
					</a>

					<a
						href="#"
						className="font-montserrat font-normal text-[12px] leading-[100%] underline text-[#5B64CF]"
					>
						Smart gadgets
					</a>

					<a
						href="#"
						className="font-montserrat font-normal text-[12px] leading-[100%] underline text-[#5B64CF]"
					>
						Alarm Clock
					</a>

					<a
						href="#"
						className="font-montserrat font-normal text-[12px] leading-[100%] underline text-[#5B64CF]"
					>
						Alarm Clock
					</a>

					<a
						href="#"
						className="font-montserrat font-normal text-[12px] leading-[100%] underline text-[#5B64CF]"
					>
						Digital Radio
					</a>
				</div>
			</div>

			<div className="absolute top-[296px] left-[124px] w-[466px] h-[20px] flex items-baseline gap-[8px] hidden lg:flex">
				<div className="h-[20px] flex items-center">
					<span className="font-montserrat font-semibold text-[13px] leading-[24px] text-black">
						Related:
					</span>
				</div>
				<div className="flex items-baseline gap-[8px]">
					<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#979797]">
						Smart Tv
					</span>

					<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#979797]">
						Smart gadgets
					</span>

					<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#979797]">
						Alarm Clock
					</span>

					<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#979797]">
						Alarm Clock
					</span>

					<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#979797]">
						Digital Radio
					</span>
				</div>
			</div>
			<div className="absolute top-[328px] left-[124px] w-[739px] h-[30px] flex items-baseline gap-[8px] hidden lg:flex">
				<div className="h-[20px] flex items-center">
					<span className="font-montserrat font-semibold text-[13px] leading-[24px] text-black">
						Filter
					</span>
				</div>
				<div className="flex items-center gap-[8px]">
					{/* Smart Watch */}
					<div className="flex items-center justify-center gap-[4px] w-[132px] h-[30px] rounded-[20px] py-[8px] px-[12px] bg-[#DEEEBF]">
						<span className="w-[88px] font-montserrat font-medium text-[13px] leading-[1] text-center text-[#0B1A16] flex items-center justify-center h-full">
							Smart Watch
						</span>
						<div className="w-[16px] h-[16px] flex items-center">
							<img
								src="/assets/search/Icons/cancel.svg"
								alt="Remove"
								className="w-full h-full"
							/>
						</div>
					</div>

					{/* Only Amazon items */}
					<div className="flex items-center justify-center gap-[4px] w-[132px] h-[30px] rounded-[20px] py-[8px] px-[12px] bg-[#DEEEBF]">
						<span className="w-[88px] font-montserrat font-medium text-[13px] leading-[1] text-center text-[#0B1A16] whitespace-nowrap flex items-center justify-center h-full">
							Only Amazon
						</span>
						<div className="w-[16px] h-[16px] flex items-center">
							<img
								src="/assets/search/Icons/cancel.svg"
								alt="Remove"
								className="w-full h-full"
							/>
						</div>
					</div>

					<div className="flex items-center justify-center gap-[4px] w-[132px] h-[30px] rounded-[20px] py-[8px] px-[12px] bg-[#DEEEBF]">
						<span className="w-[88px] font-montserrat font-medium text-[13px] leading-[1] text-center text-[#0B1A16] whitespace-nowrap flex items-center justify-center h-full">
							Only Amazon
						</span>
						<div className="w-[16px] h-[16px] flex items-center">
							<img
								src="/assets/search/Icons/cancel.svg"
								alt="Remove"
								className="w-full h-full"
							/>
						</div>
					</div>

					<div className="flex items-center justify-center gap-[4px] w-[132px] h-[30px] rounded-[20px] py-[8px] px-[12px] bg-[#DEEEBF]">
						<span className="w-[88px] font-montserrat font-medium text-[13px] leading-[1] text-center text-[#0B1A16] whitespace-nowrap flex items-center justify-center h-full">
							Only Amazon
						</span>
						<div className="w-[16px] h-[16px] flex items-center">
							<img
								src="/assets/search/Icons/cancel.svg"
								alt="Remove"
								className="w-full h-full"
							/>
						</div>
					</div>
				</div>
			</div>

			<div className="hidden md:block absolute w-[340px] h-[562px] top-[374px] left-[72px] rounded-[4px] pr-[16px] pl-[16px] bg-[#E3E6E5]">
				<div className="flex items-center gap-[10px] w-[308px] h-[40px] pr-[24px] pl-[24px]">
					{/* Icon - replace with your actual icon component or SVG */}
					<div className="w-[16px] h-[16px]">
						<img
							src="assets/search/Icons/price.svg"
							alt="Gadgets"
							className="w-[16px] h-[16px]"
						/>
					</div>

					{/* Price text */}
					<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
						Price
					</span>
				</div>
				<div className="w-[308px] h-[92.003px] pt-[24px] pr-[24px] pb-[36px] pl-[24px]">
					<div className="w-[260px] h-[32.003px] rounded-full pt-[14px] px-[8px] pb-[14px]">
						{/* Range Slider Track */}
						<div className="relative w-[244px] h-[4px] bg-[#A7C56A] rounded-full">
							{/* Segmented Filler - now uses single color */}
							<div className="absolute h-full w-full bg-[#A7C56A] rounded-full"></div>

							{/* Breakpoint Markers */}
							<div className="absolute left-0 top-1/2 w-3 h-3 -ml-1.5 -mt-1.5 bg-white border-2 border-[#A7C56A] rounded-full"></div>
							<div className="absolute left-[10%] top-1/2 w-3 h-3 -ml-1.5 -mt-1.5 bg-white border-2 border-[#A7C56A] rounded-full"></div>
							<div className="absolute left-[50%] top-1/2 w-3 h-3 -ml-1.5 -mt-1.5 bg-white border-2 border-[#A7C56A] rounded-full"></div>
							<div className="absolute left-full top-1/2 w-3 h-3 -ml-1.5 -mt-1.5 bg-white border-2 border-[#A7C56A] rounded-full"></div>

							{/* Labels below markers */}
							<div className="absolute left-0 top-3 -ml-2 text-xs text-gray-600">
								0
							</div>
							<div className="absolute left-[10%] top-3 -ml-2 text-xs text-gray-600">
								10
							</div>
							<div className="absolute left-[50%] top-3 -ml-3 text-xs text-gray-600">
								50
							</div>
							<div className="absolute left-full top-3 -ml-4 text-xs text-gray-600">
								100
							</div>
						</div>
					</div>
				</div>
				<div className="w-[308px] h-[100px] min-w-[176px] flex flex-col gap-[8px]">
					{/* Header */}
					<div className="w-[308px] h-[17px] pr-[24px] pl-[24px]">
						<div className="w-[260px] h-[17px] flex items-center gap-[8px]">
							<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
								Price Unit Range
							</span>
						</div>
					</div>

					{/* Labels and buttons container */}
					<div className="w-[308px] h-[72px] p-[20px] flex items-start relative">
						{/* Minimum section */}
						<div className="absolute left-[28px] top-[0px] flex flex-col gap-[8px]">
							<span className="font-montserrat font-semibold text-[12px] leading-[100%] text-[#47645D]">
								Minimum
							</span>
							<button className="w-[124px] h-[32px] rounded-[8px] border border-[#193D34] pl-[12px] flex items-center">
								<span className="font-montserrat font-normal text-[14px] leading-[100%] text-[#17382F]">
									USD $
								</span>
							</button>
						</div>

						{/* Maximum section */}
						<div className="absolute left-[164px] top-[0px] flex flex-col gap-[8px]">
							<span className="font-montserrat font-semibold text-[12px] leading-[100%] text-[#47645D]">
								Maximum
							</span>
							<button className="w-[124px] h-[32px] rounded-[8px] border border-[#193D34] pl-[12px] flex items-center">
								<span className="font-montserrat font-normal text-[14px] leading-[100%] text-[#17382F]">
									USD $
								</span>
							</button>
						</div>
					</div>
				</div>
				<div className="w-[308px] h-[40px] pr-[24px] pl-[24px] flex items-center gap-[10px]">
					{/* Icon */}
					<img
						src="/assets/search/Icons/trend.svg"
						alt="Trend icon"
						className="w-[16px] h-[16px]"
					/>

					{/* Text container */}
					<div className="w-[204px] h-[40px] flex items-center gap-[8px]">
						<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
							Trend
						</span>
					</div>

					<img
						src="/assets/search/Icons/arrow_down_filter.svg"
						alt="Additional icon"
						className="w-[20px] h-[20px]"
					/>
				</div>
				<div className="w-[308px] h-[40px] pr-[24px] pl-[24px] flex items-center gap-[10px]">
					{/* Icon */}
					<img
						src="/assets/search/Icons/marketplace.svg"
						alt="Marketplace icon"
						className="w-[16px] h-[16px]"
					/>

					{/* Text container */}
					<div className="w-[204px] h-[40px] flex items-center gap-[8px]">
						<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
							Marketplace
						</span>
					</div>

					<img
						src="/assets/search/Icons/arrow_down_filter.svg"
						alt="Additional icon"
						className="w-[20px] h-[20px]"
					/>
				</div>
				<div className="w-[308px] h-[40px] pr-[24px] pl-[24px] flex items-center gap-[10px]">
					{/* Icon */}
					<img
						src="/assets/search/Icons/social_media.svg"
						alt="Social Media icon"
						className="w-[16px] h-[16px]"
					/>

					{/* Text container */}
					<div className="w-[204px] h-[40px] flex items-center gap-[8px]">
						<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
							Social Media
						</span>
					</div>

					<img
						src="/assets/search/Icons/arrow_up_filter.svg"
						alt="Additional icon"
						className="w-[20px] h-[20px]"
					/>
				</div>
				<div className="w-[308px] h-[40px] pr-[24px] pl-[24px] flex items-center gap-[10px]">
					{/* Icon */}
					<img
						src="/assets/search/Icons/shipping.svg"
						alt="Shipping icon"
						className="w-[16px] h-[16px]"
					/>

					{/* Text container */}
					<div className="w-[204px] h-[40px] flex items-center gap-[8px]">
						<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
							Shipping
						</span>
					</div>

					<img
						src="/assets/search/Icons/arrow_up_filter.svg"
						alt="Additional icon"
						className="w-[20px] h-[20px]"
					/>
				</div>

				<div className="w-[308px] h-[40px] pr-[24px] pl-[24px] flex items-center gap-[10px]">
					{/* Icon */}
					<img
						src="/assets/search/Icons/order_amount.svg"
						alt="Order Amount icon"
						className="w-[16px] h-[16px]"
					/>

					{/* Text container */}
					<div className="w-[204px] h-[40px] flex items-center gap-[8px]">
						<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
							Order Amount
						</span>
					</div>

					<img
						src="/assets/search/Icons/arrow_up_filter.svg"
						alt="Additional icon"
						className="w-[20px] h-[20px]"
					/>
				</div>

				<div className="w-[308px] h-[40px] pr-[24px] pl-[24px] flex items-center gap-[10px]">
					{/* Icon */}
					<img
						src="/assets/search/Icons/review_store.svg"
						alt="Review Score icon"
						className="w-[16px] h-[16px]"
					/>

					{/* Text container */}
					<div className="w-[204px] h-[40px] flex items-center gap-[8px]">
						<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
							Review Score
						</span>
					</div>

					<img
						src="/assets/search/Icons/arrow_up_filter.svg"
						alt="Additional icon"
						className="w-[20px] h-[20px]"
					/>
				</div>
				<div className="w-[308px] h-[40px] pr-[24px] pl-[24px] flex items-center gap-[10px]">
					{/* Icon */}
					<img
						src="/assets/search/Icons/categories.svg"
						alt="Categories icon"
						className="w-[16px] h-[16px]"
					/>

					{/* Text container */}
					<div className="w-[204px] h-[40px] flex items-center gap-[8px]">
						<span className="font-montserrat font-semibold text-[14px] leading-[100%] align-middle text-[#464646]">
							Categories
						</span>
					</div>
					<img
						src="/assets/search/Icons/arrow_up_filter.svg"
						alt="Additional icon"
						className="w-[20px] h-[20px]"
					/>
				</div>
				<div className="w-[308px] h-[48px] p-[8px]">
					<button className="w-[292px] h-[32px] rounded-[24px] border border-[#193D34] p-[8px] flex items-center justify-center gap-[2px]">
						<span className="font-montserrat font-medium text-[13px] leading-[24px] text-center align-middle text-[#193D34]">
							See More
						</span>
					</button>
				</div>
			</div>

			<div className="absolute w-[868px] h-[562px] top-[374px] left-[calc(72px+340px+20px)] pt-[20px] pr-[16px] pb-[20px] pl-[16px] gap-[20px] rounded-[16px] bg-[#C5E190] flex flex-col hidden lg:flex">
				<div className="flex flex-row items-center gap-[20px]">
					{/* "LOWEST PRICE !" Text */}
					<div className="w-[64px] flex items-center justify-center">
						<span
							className="w-[32px] text-[#008500] font-montserrat font-semibold text-[32px] leading-[32px] text-center"
							style={{
								transform: "rotate(180deg)",
								writingMode: "vertical-rl",
							}}
						>
							LOWEST PRICE !
						</span>
					</div>

					{/* Product Cards */}
					<div className="flex flex-row gap-[20px] mt-5">
						<Card variant="priceFilter" content={productCards[0]} />
						<Card variant="priceFilter" content={productCards[1]} />
					</div>
				</div>
			</div>

			<div className="absolute w-[1256px] h-[974px]  left-[72px] top-[956px] hidden lg:flex">
				<CustomSlider
					type="search"
					cards={productCards}
					cardsToShow={6}
					CardComponent={Card}
				/>
			</div>
			<div className="absolute w-[1400px] h-[896px] top-[2058px] px-[120px] gap-[16px] flex flex-col   hidden lg:flex">
				{/* Child Div 1: Title */}
				<div className="w-[1160px] h-[24px]">
					<p className="font-montserrat font-bold text-[20px] leading-[32px] text-[#000000]">
						Dropshipping Automation Software
					</p>
				</div>

				{/* Child Div 2: Description */}
				<div className="w-[1160px] h-[105px]">
					<p className="font-montserrat font-normal text-[12px] leading-[100%] text-[#000000]">
						Rbetraj's Dropshipping Automation Software efficiently and
						accurately finds winning dropshipping products for your online
						store.
						<br />
						<br />
						Because drop shippers compete fiercely, product research can quite
						often be overwhelming. It's hard to differentiate your products with
						so many drop shippers selling the same product. Manually researching
						trending products can take many hours and be tedious.
						<br />
						<br />
						With Rbetraj's dropshipping product finder, you can eliminate the
						tediousness of the whole process. Our automation software monitors
						market trends, consumer behaviour, and stock availability in real
						time, making product sourcing quicker and more efficient.
					</p>
				</div>

				{/* Child Div 3: Features/Reasons */}
				<div className="w-[1160px] h-auto">
					<p className="font-montserrat font-normal text-[12px] leading-[100%] text-[#000000]">
						Here are the top reasons why you should use Rbetraj's best automated
						dropshipping software:
						<br />
						<br />
						<strong>Find Profitable Products With Ease</strong>
						<br />
						<br />
						You want to sell high-margin products as a drop shipper to make
						substantial profits. Figuring out the right strategy to source
						high-value items manually can take a very long time. Our
						dropshipping product research software allows you to source trending
						items in profitable niches and 4X your profit-earning potential.
						<br />
						<br />
						Find Reliable Suppliers To Find
						<strong>Winning Products for Dropshipping</strong>
						<br />
						<br />
						Among so many suppliers online, you would want to stick to those who
						are reliable with their shipping times and product quality.
						Unreliable and unresponsive vendors can dent your reputation and
						hold you back from keeping your promise to the customer. With our
						dropshipping finder tool, you will never have to worry about teaming
						up with unreliable suppliers.
						<br />
						<br />
						We partner with trusted names like Walmart, AliExpress, Etsy,
						Amazon, eBay, etc., so you will never have to worry about delayed
						shipping and poor product quality again.
						<br />
						<br />
						<strong>Track Product Performance with Ease</strong>
						<br />
						<br />
						Manually interpreting performance metrics can take up a huge chunk
						of your time. Rberaj's winning dropshipping software takes the
						tediousness out of the process and helps you pick products that are
						very likely to earn profits. The tool helps you
						<strong>find trending products for dropshipping</strong>, determines
						which products are worth selling and keeps tabs on profit margin and
						product demand.
						<br />
						<br />
						Leverage our
						<strong>Dropshipping Automation Software</strong> to Scale Your
						Business
						<br />
						<br />
						Most drop shippers fail to scale their business because they are
						often trying to eliminate repetitive tasks. With our dropshipping
						automation software, tasks like product research, supplier vetting,
						and managing multiple product listings are easy and super efficient.
						By automating cumbersome tasks, you acquire more time and creativity
						to scale your business and take it to new heights.
						<br />
						<br />
						<strong>Make Data-Driven Decisions, Always!</strong>
						<br />
						<br />
						Our automated dropshipping tool doesn't just find basic information
						on the products you are sourcing. It gives you key insights based on
						data, which will empower you to make better decisions.
						<br />
						<br />
						The product finder tool is precise at analyzing crucial metrics like
						customer reviews, profit margins, price variations (real-time),
						market trends, sales volume, and much more. Such detailed insights
						make evaluating the true potential of any product much easier.
						<br />
						<br />
						For example, you will get important insights about how customers
						rate a particular product. Does it have high ratings or negative
						reviews? Based on this rich data and actionable insights that help
						you choose products, you are likely to boost your product sales and
						optimize profitability.
						<br />
						<br />
						<strong>Integrate Effortlessly with top eCommerce Platforms</strong>
						<br />
						<br />
						Dropshippers can effortlessly connect their online dropshipping
						store with top eCommerce platforms, taking away the need to manually
						export and import. Once you connect your store to our dropshipping
						automated software, you can instantly import products directly to
						your store.
						<br />
						<br />
						Product details like titles, images, and descriptions are
						automatically added, ensuring consistency.
						<br />
						<br />
						<strong>Real-Time Price Updation</strong>
						<br />
						<br />
						Most suppliers increase, decrease, or promote their products with
						new offers. However, you need not worry about keeping tabs on these
						variations. Our tool automatically updates changes in real-time,
						preventing errors or mismatched information. Therefore, your product
						catalogue is always up-to-date!
						<br />
						<br />
						Get your hands on the best automated dropshipping software. You can
						achieve greater success and streamline your online store with
						minimal effort.
					</p>
				</div>
			</div>
			{/*Mobile view*/}
			<div className="lg:hidden w-[378px] h-[268px] pt-4 pr-5 pb-4 pl-5 gap-4 bg-[#193D34]">
				{/* Navigation Tabs */}
				<div className="w-[378px] h-[36px] pr-5 pb-2 pl-1 gap-1 flex items-center mt-4">
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Products
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Shops
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Trends
						</span>
					</div>
				</div>

				<div className="w-[338px] h-[40px] rounded-lg border-[1.6px] border-gray-300 overflow-hidden mt-3">
					<div className="relative flex items-center w-full h-full">
						<input
							type="text"
							placeholder="Search product.."
							className="pl-4 pr-12 w-full h-full bg-white text-black placeholder:text-gray-400 outline-none focus:ring-0"
						/>
						<button className="absolute right-0 flex items-center justify-center w-[40px] h-full bg-[#B7D974] hover:bg-[#A9C864] transition-colors">
							<img
								src="/assets/home/topnav/search.png"
								alt="Search"
								className="w-[20px] h-[20px]"
							/>
						</button>
					</div>
				</div>

				<div className="lg:hidden w-[338px] flex flex-wrap items-center mt-6 gap-4">
					{/* Filter By Label */}
					<span className="font-montserrat font-normal text-[16px] leading-[32px] text-[#F6F6F6] whitespace-nowrap">
						Filter By :
					</span>

					{/* Buttons */}
					{[
						"Top Sellers",
						"Only Amazon",
						"Only Alibaba",
						"Top in Marketplace",
					].map((label, index) => (
						<button
							key={index}
							className="object-contain  h-[30px] px-[12px] py-[8px] flex items-center justify-center gap-[10px] rounded-[20px] border border-[#A7C56A] bg-[#47645D]"
						>
							<span className="whitespace-nowrap  font-montserrat font-medium text-[13px] leading-[100%] tracking-[0%] text-center text-white">
								{label}
							</span>
						</button>
					))}
				</div>
			</div>
			<div className="lg:hidden w-[378px] h-[313px] pr-5 pl-5 gap-3 flex flex-col mt-3">
				{/* Breadcrumb Navigation */}
				<div className="w-full flex gap-1 overflow-x-auto py-1">
					<div className="flex-shrink-0 flex items-center gap-1 px-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
							Electronic
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex-shrink-0 flex items-center gap-1 px-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
							Gadgets
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex-shrink-0 flex items-center gap-1 px-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Smart Watches
						</span>
						<img
							src="assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
				</div>

				{/* Results Header */}
				<div className="w-full flex flex-col gap-1">
					<div className="w-full font-montserrat font-semibold text-[28px] leading-[32px] text-black">
						Results
					</div>
					<div className="w-full flex gap-1 items-center">
						<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#47645D]">
							1280 results of
						</span>
						<span className="font-montserrat font-semibold text-[12px] leading-[100%] text-[#47645D]">
							Smart Watch
						</span>
					</div>
				</div>

				{/* Did You Mean Links */}
				<div className="w-full flex flex-col gap-1">
					<span className="font-montserrat font-semibold text-[13px] leading-[24px] text-black">
						Did you mean...
					</span>
					<div className="w-full flex flex-wrap gap-2">
						{["Smart Tv", "Smart gadgets", "Alarm Clock", "Digital Radio"].map(
							(item) => (
								<a
									key={item}
									href="#"
									className="font-montserrat font-normal text-[12px] leading-[100%] underline text-[#5B64CF]"
								>
									{item}
								</a>
							)
						)}
					</div>
				</div>

				{/* Related Terms */}
				<div className="w-full flex flex-col gap-1">
					<span className="font-montserrat font-semibold text-[13px] leading-[24px] text-black">
						Related:
					</span>
					<div className="w-full flex flex-wrap gap-2">
						{["Smart Tv", "Smart gadgets", "Alarm Clock", "Digital Radio"].map(
							(item) => (
								<span
									key={item}
									className="font-montserrat font-normal text-[12px] leading-[100%] text-[#979797]"
								>
									{item}
								</span>
							)
						)}
					</div>
				</div>

				<div className="w-full flex flex-col gap-1">
					{/* Filter label */}
					<div className="flex items-center gap-2">
						{/* Buttons container */}
						<div className="w-full flex flex-wrap gap-2">
							<span className="font-montserrat font-semibold text-[13px] leading-[24px] text-black ">
								Filter By
							</span>
							<div className="flex items-center justify-between gap-1 w-[132px] h-[30px] rounded-full px-3 py-2 bg-[#DEEEBF]">
								<span className="font-montserrat font-medium text-[13px] leading-[100%] text-[#0B1A16] truncate">
									Smart Watch
								</span>
								<img
									src="assets/search/Icons/cancel.svg"
									alt="Remove"
									className="w-4 h-4"
								/>
							</div>

							{/* Dynamic buttons */}
							{[1, 2, 3].map((item) => (
								<div
									key={item}
									className="flex items-center justify-between gap-1 w-[132px] h-[30px] rounded-full px-3 py-2 bg-[#DEEEBF]"
								>
									<span className="font-montserrat font-medium text-[13px] leading-[100%] text-[#0B1A16] whitespace-nowrap">
										Only Amazon
									</span>
									<img
										src="assets/search/Icons/cancel.svg"
										alt="Remove"
										className="w-4 h-4"
									/>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>

			<div className="lg:hidden flex flex-row items-center gap-5 sm:gap-5 bg-[#C5E190] overflow-hidden">
				{/* "LOWEST PRICE !" Text */}
				<div className="w-[64px] flex items-center justify-center pl-2">
					<span
						className="w-[32px] text-[#008500] font-montserrat font-semibold text-[32px] leading-[32px] text-center"
						style={{
							transform: "rotate(180deg)",
							writingMode: "vertical-rl",
						}}
					>
						LOWEST PRICE !
					</span>
				</div>

				{/* Product Cards */}
				<div className="flex flex-row gap-5 sm:gap-5 mt-5">
					<Card variant="priceFilterMobile" content={productCards[0]} />
					<Card variant="priceFilterMobile" content={productCards[1]} />
				</div>
			</div>
			<div className="lg:hidden flex flex-row w-[100%] h-[1406px] items-center gap-5 sm:gap-5 overflow-hidden mt-3">
				<CustomSlider
					type="searchMobile"
					cards={productCards}
					cardsToShow={6}
					CardComponent={Card}
				/>
			</div>

			<div className="lg:hidden w-[100%] h-auto  px-[16px] gap-[16px] flex flex-col mb-20">
				{/* Child Div 1: Title */}
				<div className="w-[100%] h-[auto]">
					<p className="font-montserrat font-bold text-[20px] leading-[32px] text-[#000000]">
						Dropshipping Automation Software
					</p>
				</div>

				{/* Child Div 2: Description */}
				<div className="w-[100%] h-[auto]">
					<p className="font-montserrat font-normal text-[12px] leading-[100%] text-[#000000]">
						Rbetraj's Dropshipping Automation Software efficiently and
						accurately finds winning dropshipping products for your online
						store.
						<br />
						<br />
						Because drop shippers compete fiercely, product research can quite
						often be overwhelming. It's hard to differentiate your products with
						so many drop shippers selling the same product. Manually researching
						trending products can take many hours and be tedious.
						<br />
						<br />
						With Rbetraj's dropshipping product finder, you can eliminate the
						tediousness of the whole process. Our automation software monitors
						market trends, consumer behaviour, and stock availability in real
						time, making product sourcing quicker and more efficient.
					</p>
				</div>

				{/* Child Div 3: Features/Reasons */}
				<div className="w-[100%] h-auto">
					<p className="font-montserrat font-normal text-[12px] leading-[100%] text-[#000000]">
						Here are the top reasons why you should use Rbetraj's best automated
						dropshipping software:
						<br />
						<br />
						<strong>Find Profitable Products With Ease</strong>
						<br />
						You want to sell high-margin products as a drop shipper to make
						substantial profits. Figuring out the right strategy to source
						high-value items manually can take a very long time. Our
						dropshipping product research software allows you to source trending
						items in profitable niches and 4X your profit-earning potential.
						<br />
						<br />
						<strong>
							Find Reliable Suppliers To Find Winning Products for Dropshipping
						</strong>
						<br />
						Among so many suppliers online, you would want to stick to those who
						are reliable with their shipping times and product quality.
						Unreliable and unresponsive vendors can dent your reputation and
						hold you back from keeping your promise to the customer. With our
						dropshipping finder tool, you will never have to worry about teaming
						up with unreliable suppliers.
						<br />
						<br />
						We partner with trusted names like Walmart, AliExpress, Etsy,
						Amazon, eBay, etc., so you will never have to worry about delayed
						shipping and poor product quality again.
						<br />
						<br />
						<strong>Track Product Performance with Ease</strong>
						<br />
						Manually interpreting performance metrics can take up a huge chunk
						of your time. Rberaj's winning dropshipping software takes the
						tediousness out of the process and helps you pick products that are
						very likely to earn profits. The tool helps you find trending
						products for dropshipping, determines which products are worth
						selling and keeps tabs on profit margin and product demand.
						<br />
						<br />
						<strong>
							Leverage our Dropshipping Automation Software to Scale Your
							Business
						</strong>
						<br />
						Most drop shippers fail to scale their business because they are
						often trying to eliminate repetitive tasks. With our dropshipping
						automation software, tasks like product research, supplier vetting,
						and managing multiple product listings are easy and super efficient.
						By automating cumbersome tasks, you acquire more time and creativity
						to scale your business and take it to new heights.
						<br />
						<br />
						<strong>Make Data-Driven Decisions, Always!</strong>
						<br />
						Our automated dropshipping tool doesn't just find basic information
						on the products you are sourcing. It gives you key insights based on
						data, which will empower you to make better decisions.
						<br />
						<br />
						The product finder tool is precise at analyzing crucial metrics like
						customer reviews, profit margins, price variations (real-time),
						market trends, sales volume, and much more. Such detailed insights
						make evaluating the true potential of any product much easier.
						<br />
						<br />
						For example, you will get important insights about how customers
						rate a particular product. Does it have high ratings or negative
						reviews? Based on this rich data and actionable insights that help
						you choose products, you are likely to boost your product sales and
						optimize profitability.
						<br />
						<br />
						<strong>Integrate Effortlessly with top eCommerce Platforms</strong>
						<br />
						Dropshippers can effortlessly connect their online dropshipping
						store with top eCommerce platforms, taking away the need to manually
						export and import. Once you connect your store to our dropshipping
						automated software, you can instantly import products directly to
						your store.
						<br />
						<br />
						Product details like titles, images, and descriptions are
						automatically added, ensuring consistency.
						<br />
						<br />
						<strong>Real-Time Price Updation</strong>
						<br />
						Most suppliers increase, decrease, or promote their products with
						new offers. However, you need not worry about keeping tabs on these
						variations. Our tool automatically updates changes in real-time,
						preventing errors or mismatched information. Therefore, your product
						catalogue is always up-to-date!
						<br />
						<br />
						Get your hands on the best automated dropshipping software. You can
						achieve greater success and streamline your online store with
						minimal effort.
					</p>
				</div>
			</div>
			<Footer desktop="top-[2900px]" />
		</>
	);
};

export default Search;
